import * as yup from 'yup'
import { REQUIRED_FIELD } from 'constants/errors'

export const schemaAddNewRole = yup.object().shape({
  name: yup.string().required(REQUIRED_FIELD),
})
